import { render, staticRenderFns } from "./FinalDatesColumnComponent.vue?vue&type=template&id=75864d17&"
import script from "./FinalDatesColumnComponent.vue?vue&type=script&lang=ts&"
export * from "./FinalDatesColumnComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75864d17')) {
      api.createRecord('75864d17', component.options)
    } else {
      api.reload('75864d17', component.options)
    }
    module.hot.accept("./FinalDatesColumnComponent.vue?vue&type=template&id=75864d17&", function () {
      api.rerender('75864d17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/InProcessing/FinalDatesColumnComponent.vue"
export default component.exports